
  document.addEventListener("DOMContentLoaded", function () {
    // Update variant ID based on selected options
    function updateVariantId(productCard) {
      const variantsData = JSON.parse(productCard.getAttribute('data-variants'));
      const selectedColor = productCard.querySelector('.swatch-option.active')?.getAttribute('title')?.trim();
      const selectedSize = productCard.querySelector('.product-size.active')?.getAttribute('data-size')?.trim();

      const matchingVariant = variantsData.find(variant => {
        let matchesColor = true;
        let matchesSize = true;

        if (selectedColor) {
          matchesColor = variant.options.some(opt => opt.toLowerCase() === selectedColor.toLowerCase());
        }
        if (selectedSize) {
          matchesSize = variant.options.some(opt => opt.toLowerCase() === selectedSize.toLowerCase());
        }

        return matchesColor && matchesSize;
      });

      if (matchingVariant) {
        const variantInput = productCard.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = matchingVariant.id;
        }
      }
    };

    // Swatch color click
    document.body.addEventListener('click', function () {
    document.querySelectorAll('.swatch-option').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        const parent = swatch.parentElement;
        parent.querySelectorAll('.swatch-option').forEach(el => el.classList.remove('active'));
        swatch.classList.add('active');

        const newImage = swatch.getAttribute('data-image');
        const newPrice = swatch.getAttribute('data-price');
        const compare_newPrice = swatch.getAttribute('data-compare_price');
        const productCard = swatch.closest('.tab-product-image');
       const available = swatch.getAttribute('data-available');
      //  console.log(swatch.closest('.grid__item'))
        if(available == 'true'){
         swatch.closest('.grid__item').querySelector('.add-tocart-icon').disabled = false;
           swatch.closest('.grid__item').querySelector('.add-tocart-icon span').innerText ='Add to cart';
          swatch.closest('.grid__item').querySelector('.product-media').classList.remove('sold_out_image');
          
        }else{
          swatch.closest('.grid__item').querySelector('.add-tocart-icon').disabled = true;
           swatch.closest('.grid__item').querySelector('.add-tocart-icon span').innerText ='Sold Out';
          swatch.closest('.grid__item').querySelector('.product-media').classList.add('sold_out_image');
        }

        if (newImage) {
          const imgElement = productCard.querySelector('.card__media img');
          if (imgElement) imgElement.src = newImage;
          if (imgElement) imgElement.srcset = newImage;
        }
        const priceElement = productCard.querySelector('.tab-product-price');
        if(compare_newPrice){
          var price1 = compare_newPrice.replace(/[^\d.-]/g, '');
var price2 = newPrice.replace(/[^\d.-]/g, '');
          var dif = parseInt(price1) - parseInt(price2);
          var peroff = Math.round((dif/price1)*100);
         // console.log((Math.round((dif/price1)*100)));
         if (priceElement) priceElement.innerHTML = `<s  class="price-item price-item--regular">${compare_newPrice}</s>${newPrice}`;
           swatch.closest('.grid__item').querySelector('.card__badge span').textContent = `${peroff}%`;
        }
       else if (newPrice) {
          
          if (priceElement) priceElement.textContent = newPrice;
        }

        updateVariantId(productCard);
      });
    });
    });
    

    // Size option click
    document.body.addEventListener('click', function () {
    document.querySelectorAll('.product-sizes .product-size').forEach(function (sizeEl) {
      sizeEl.addEventListener('click', function () {
        const newImage1 = sizeEl.getAttribute('data-image');
        const productCard1 = sizeEl.closest('.tab-product-image');
        const price = sizeEl.getAttribute('data-price');
        const compare_newPrice_size = sizeEl.getAttribute('data-compare_price');
        const container = sizeEl.closest('.tab-product-image');
        const priceEl = container.querySelector('.tab-product-price');
        if (newImage1) {
          const imgElement1 = productCard1.querySelector('.card__media img');
          if (imgElement1) imgElement1.src = newImage1;
          if (imgElement1) imgElement1.srcset = newImage1;
        }
        if(compare_newPrice_size){
          var price1 = compare_newPrice_size.replace(/[^\d.-]/g, '');
var price2 = price.replace(/[^\d.-]/g, '');
          var dif = parseInt(price1) - parseInt(price2);
          var peroff = Math.round((dif/price1)*100);
         // console.log((Math.round((dif/price1)*100)));
         if (priceEl) priceEl.innerHTML = `<s  class="price-item price-item--regular">${compare_newPrice_size}</s>${price}`;
           sizeEl.closest('.grid__item').querySelector('.card__badge span').textContent = `${peroff}%`;
        }
 else if (priceEl) priceEl.textContent = price;

        container.querySelectorAll('.product-size').forEach(el => el.classList.remove('active'));
        sizeEl.classList.add('active');

        updateVariantId(container);
        const available = sizeEl.getAttribute('data-available');
        if(available == 'true'){
         sizeEl.closest('.grid__item').querySelector('.add-tocart-icon').disabled = false;
           sizeEl.closest('.grid__item').querySelector('.add-tocart-icon span').innerText ='Add to cart';
          sizeEl.closest('.grid__item').querySelector('.product-media').classList.remove('sold_out_image');
          
        }else{
          sizeEl.closest('.grid__item').querySelector('.add-tocart-icon').disabled = true;
           sizeEl.closest('.grid__item').querySelector('.add-tocart-icon span').innerText ='Sold Out';
          sizeEl.closest('.grid__item').querySelector('.product-media').classList.add('sold_out_image');
        }
      });
    });
    });
    

    // AJAX Add to Cart
           $('body').on('click','.ajax-add-to-cart button',function(e){
       e.preventDefault();
    var formdata = $(this).parents('form').serialize();
      if($(this).hasClass('disabled')){
      return;  
      }
        var id = $(this).closest('form').find('[name="id"]').val();
 let formData = {
    items: [{
      id: id,
      quantity: 1
    }],
    sections: ['cart-drawer']
  };
        fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    }).then(response => {
      return response.json();
    }).then(result => { 
          console.log(result);
         let cartDrawerHtml = result.sections && result.sections['cart-drawer'];
          let cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && cartDrawerHtml) {
  const newCartDrawer = document.createElement('div');
  newCartDrawer.innerHTML = cartDrawerHtml;
  cartDrawer.replaceWith(newCartDrawer.firstElementChild);
  cartDrawer.classList.remove('is-empty');
   $('#cart-icon-bubble')[0].click();
  let cartDrawer_count = parseInt(document.querySelector('cart-drawer-items').getAttribute('data-items'));
  if(cartDrawer_count > 0){
    $('.cart-count-bubble').remove();
    $('#cart-icon-bubble').append(`<div class="cart-count-bubble"><span aria-hidden="true">${cartDrawer_count}</span><span class="visually-hidden">${cartDrawer_count} items</span></div>`);
  }
}
    }).catch((error) => {
      console.error('Error:', error);
    });
  });

    // function updateCart(){
    //   $.getJSON('/cart.json').then(cart => {
    //               	fetch('/cart?view=cart-drawer').then(response => response.text())
    //                 .then(text => {
    //                     const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
    //                     const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
    //                     //const totalPrice=sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
    //                     $('#CartDrawer').html(cartFormInnerHTML)
    //                     $('cart-drawer').removeClass('is-empty')
    //                     $('cart-drawer-items').removeClass('is-empty')
    //                   if($('#cart-icon-bubble .cart-count-bubble').length===0){
    //                     const cartNumber=document.createElement('div')
    //                     cartNumber.className='cart-count-bubble'
    //                     cartNumber.innerHTML=`
    //                     <span aria-hidden="true">${cart.item_count}</span>
    //                     <span class="visually-hidden">${cart.item_count} items</span>
    //                     `
    //                     $('#cart-icon-bubble').append(cartNumber)
    //                   }else{
    //                      $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
    //                   }
    //                    $('#cart-icon-bubble')[0].click()
    //                 })
	   //          });
    // }

    // Slick slider init
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content-item');

    function initSlickSlider(container) {
      const $slider = $(container).find('.product-list');
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          prevArrow: '<button type="button" class="prev slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M10 17.63L2.185 9.815L10 2" stroke="#C8A564" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          nextArrow: '<button type="button" class="next slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none"><path d="M2 17.63L9.815 9.815L2 2" stroke="#C8A564" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
          dots: false,
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: {
            slidesToShow: 1
          } }
          ]
        });
      }
    }

    // Initialize first slider
    initSlickSlider(contents[0]);

    // Tab switch functionality
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        button.classList.add('active');
        contents[index].classList.add('active');

        initSlickSlider(contents[index]);
      });
    });

  });
